export default __webpack_public_path__ + "static/careers-pc-mag-awards-1fe11e1441979467600dfcbbab64104a.png";